// extracted by mini-css-extract-plugin
export var header = "Social-module--header--547a1";
export var image = "Social-module--image--a15f3";
export var list = "Social-module--list--95a8e";
export var listItem = "Social-module--listItem--43f81";
export var rubberBand = "Social-module--rubberBand--ede8d";